import { call, put, select } from 'redux-saga/effects';
import { urls } from '../../../common/urls';
import { getHttp, getHttpwithtoken, postHttpwithtoken } from '../../../common/ApiCall';
import {
  driverListOnCallFailure,
  driverListOnCallLoading,
  driverListOnCallSuccess,
  getdriverOnCallFailure,
  getdriverOnCallLoading,
  getdriverOnCallSuccess,
  submitRettingFailure,
  submitRettingLoading,
  submitRettingSuccess,
  driverNotificationFailure,
  driverNotificationLoading,
  driverNotificationSuccess,
} from '../../ducks/CustomerOnCallSlice';

// Driver List On Call Handler
export function* handlerCustomerOnCallDriverList(action: any): Generator<any, void, any> {
  try {
    yield put(driverListOnCallLoading());
    const response: any = yield call(getHttpwithtoken, `${urls.baseURL}${urls.driverlist}${action.payload}`);
    
    if (response.success) {
      yield put(driverListOnCallSuccess(response.data));
    } else {
      yield put(driverListOnCallFailure(response.message || 'Failed to get driver list'));
    }
  } catch (error: any) {
    yield put(driverListOnCallFailure(error.message || 'Failed to get driver list'));
  }
}

// Get Driver On Call Handler
export function* handlergetdriverOnCall(action: any): Generator<any, void, any> {
  try {
    yield put(getdriverOnCallLoading());
    const url = `${urls.baseURL}${urls.getdriverOnCall}`;
    console.log('Fetching drivers from:', url);
    const response: any = yield call(getHttpwithtoken, url);
    
    console.log('Driver API response:', response);
    
    if (response.success) {
      yield put(getdriverOnCallSuccess(response.data));
    } else {
      const errorMsg = response.message || response.error || 'Failed to get driver on call';
      console.error('Driver API error response:', response);
      yield put(getdriverOnCallFailure(errorMsg));
    }
  } catch (error: any) {
    console.error('Driver API exception:', error);
    const errorMsg = error?.response?.data?.message || 
                    error?.response?.data?.error ||
                    error?.message || 
                    error?.toString() ||
                    'Failed to get driver on call';
    console.error('Driver API error message:', errorMsg);
    yield put(getdriverOnCallFailure(errorMsg));
  }
}

// Submit Feedback Handler
export function* handlerSubmitFeedback(action: any): Generator<any, void, any> {
  try {
    yield put(submitRettingLoading());
    const response: any = yield call(postHttpwithtoken, `${urls.baseURL}${urls.feedbackapi}`, action.payload);
    
    if (response.success) {
      yield put(submitRettingSuccess(response.data));
    } else {
      yield put(submitRettingFailure(response.message || 'Failed to submit feedback'));
    }
  } catch (error: any) {
    yield put(submitRettingFailure(error.message || 'Failed to submit feedback'));
  }
}

// Driver Notification Handler
export function* handlerDriverNotification(action: any): Generator<any, void, any> {
  try {
    yield put(driverNotificationLoading());
    const response: any = yield call(getHttpwithtoken, `${urls.baseURL}${urls.notifications}`);
    
    if (response.success) {
      yield put(driverNotificationSuccess(response.data));
    } else {
      yield put(driverNotificationFailure(response.message || 'Failed to get notifications'));
    }
  } catch (error: any) {
    yield put(driverNotificationFailure(error.message || 'Failed to get notifications'));
  }
}
